import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/trade-banner-mobile.png'
import _imports_1 from '@/assets/category-icons/building.svg'


const _withScopeId = n => (_pushScopeId("data-v-b646cc20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-w-full tw-gap-4" }
const _hoisted_2 = { class: "tw-w-full tw-flex tw-items-center tw-justify-between" }
const _hoisted_3 = { class: "tw-w-full tw-hidden tw-min-h-[282px] tw-relative tw-bg-white tw-border-[1px] tw-border-solid tw-border-[#DFDFDF] tw-rounded-[10px] tw-overflow-hidden rlg:!tw-inline" }
const _hoisted_4 = { class: "tw-min-h-[158px] tw-w-full tw-p-4 tw-box-border tw-bg-[#EEF1F3] tw-overflow-hidden tw-border-b-[1px] tw-border-b-[#DFDFDF] tw-border-b-solid tw-relative" }
const _hoisted_5 = { class: "tw-w-full tw-h-full tw-absolute tw-top-0 tw-right-0" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  class: "tw-w-full tw-h-full tw-object-cover"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "tw-min-h-[182px] tw-bg-transparent tw-w-full tw-p-4 tw-box-border tw-flex tw-gap-4 tw-items-end tw-absolute tw-bottom-0" }
const _hoisted_9 = { class: "tw-bg-white tw-w-full tw-rounded-lg tw-border-solid tw-border-[#DFDFDF] tw-border-[1px] tw-p-4 tw-box-border tw-flex tw-items-start tw-gap-2" }
const _hoisted_10 = {
  key: 1,
  class: "tw-min-w-[96px] tw-h-[96px] tw-overflow-hidden tw-rounded-[10.67px]"
}
const _hoisted_11 = { class: "tw-w-full tw-h-full tw-flex tw-box-border" }
const _hoisted_12 = { class: "tw-w-full tw-flex tw-items-start tw-justify-between" }
const _hoisted_13 = { class: "tw-flex tw-flex-col tw-gap-2 tw-items-start" }
const _hoisted_14 = { class: "view-rating-box" }
const _hoisted_15 = {
  key: 0,
  class: "tw-w-full tw-flex tw-gap-2 tw-items-center"
}
const _hoisted_16 = { class: "tw-min-w-[16px] tw-w-[16px] tw-h-[16px] tw-rounded-full tw-bg-[#0C0F4A] tw-flex tw-items-center tw-justify-center" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "service-badge"
}
const _hoisted_19 = { class: "tw-w-full tw-grid tw-gap-4 tw-grid-cols-2 tw-items-center" }
const _hoisted_20 = { class: "tw-w-full tw-rounded-[10px] tw-border-solid tw-border-[1px] tw-border-[#DFDFDF] tw-bg-white tw-h-[82px] tw-flex tw-flex-col tw-gap-0 tw-items-center tw-justify-center" }
const _hoisted_21 = { class: "tw-w-full tw-rounded-[10px] tw-border-solid tw-border-[1px] tw-border-[#DFDFDF] tw-bg-white tw-h-[82px] tw-flex tw-flex-col tw-gap-0 tw-items-center tw-justify-center" }
const _hoisted_22 = { class: "tw-w-full tw-rounded-[10px] tw-border-solid tw-border-[1px] tw-border-[#DFDFDF] tw-bg-white tw-p-4 tw-box-border tw-flex tw-flex-col tw-gap-6" }
const _hoisted_23 = { class: "tw-w-full tw-flex tw-items-center tw-justify-between" }
const _hoisted_24 = { class: "tw-w-full tw-flex tw-items-center tw-gap-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "tw-w-[12px] tw-min-w-[12px] tw-h-[16px]"
}, null, -1))
const _hoisted_26 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-3" }
const _hoisted_27 = { class: "tw-pt-3 tw-box-border tw-border-t-dashed-custom" }
const _hoisted_28 = {
  key: 0,
  class: "tw-w-full tw-rounded-[10px] tw-border-solid tw-border-[1px] tw-border-[#DFDFDF] tw-bg-white tw-p-4 tw-box-border tw-flex tw-flex-col tw-gap-6"
}
const _hoisted_29 = { class: "tw-w-full tw-flex tw-items-center tw-justify-between" }
const _hoisted_30 = { class: "tw-w-full tw-flex tw-items-center tw-gap-2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "tw-w-[12px] tw-min-w-[12px] tw-h-[16px]"
}, null, -1))
const _hoisted_32 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-3" }
const _hoisted_33 = { class: "tw-w-full tw-flex tw-items-start tw-flex-col tw-gap-2" }
const _hoisted_34 = {
  key: 0,
  class: "tw-pt-3 tw-box-border tw-border-t-dashed-custom"
}
const _hoisted_35 = {
  key: 1,
  class: "tw-w-full tw-rounded-[10px] tw-border-solid tw-border-[1px] tw-border-[#DFDFDF] tw-bg-white tw-p-4 tw-box-border tw-flex tw-flex-col tw-gap-6"
}
const _hoisted_36 = { class: "tw-w-full tw-flex tw-items-center tw-justify-between" }
const _hoisted_37 = { class: "tw-w-full tw-flex tw-items-center tw-gap-2" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "tw-w-[12px] tw-min-w-[12px] tw-h-[16px]"
}, null, -1))
const _hoisted_39 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-3" }
const _hoisted_40 = { class: "tw-w-full tw-flex tw-items-start tw-flex-col tw-gap-2" }
const _hoisted_41 = {
  key: 0,
  class: "tw-pt-3 tw-box-border tw-border-t-dashed-custom"
}
const _hoisted_42 = {
  key: 2,
  class: "tw-w-full tw-rounded-[10px] tw-border-solid tw-border-[1px] tw-border-[#DFDFDF] tw-bg-white tw-p-4 tw-box-border tw-flex tw-flex-col tw-gap-6"
}
const _hoisted_43 = { class: "tw-w-full tw-flex tw-items-center tw-justify-between" }
const _hoisted_44 = { class: "tw-w-full tw-flex tw-items-center tw-gap-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "tw-w-[12px] tw-min-w-[12px] tw-h-[16px]"
}, null, -1))
const _hoisted_46 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-3" }
const _hoisted_47 = { class: "tw-w-full tw-flex tw-items-start tw-flex-col tw-gap-2" }
const _hoisted_48 = {
  key: 0,
  class: "tw-pt-3 tw-box-border tw-border-t-dashed-custom"
}
const _hoisted_49 = {
  key: 3,
  class: "tw-w-full tw-rounded-[10px] tw-border-solid tw-border-[1px] tw-border-[#DFDFDF] tw-bg-white tw-p-4 tw-box-border tw-flex tw-flex-col tw-gap-6"
}
const _hoisted_50 = { class: "tw-w-full tw-flex tw-items-center tw-justify-between" }
const _hoisted_51 = { class: "tw-w-full tw-flex tw-items-center tw-gap-2" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "tw-w-[12px] tw-min-w-[12px] tw-h-[16px]"
}, null, -1))
const _hoisted_53 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-3" }
const _hoisted_54 = { class: "tw-w-full tw-flex tw-items-start tw-flex-col tw-gap-2" }
const _hoisted_55 = {
  key: 0,
  class: "tw-pt-3 tw-box-border tw-border-t-dashed-custom"
}
const _hoisted_56 = {
  key: 4,
  class: "tw-w-full tw-rounded-[10px] tw-border-solid tw-border-[1px] tw-border-[#DFDFDF] tw-bg-white tw-p-4 tw-box-border tw-flex tw-flex-col tw-gap-6"
}
const _hoisted_57 = { class: "tw-w-full tw-flex tw-items-center tw-justify-between" }
const _hoisted_58 = { class: "tw-w-full tw-flex tw-items-center tw-gap-2" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "tw-w-[12px] tw-min-w-[12px] tw-h-[16px]"
}, null, -1))
const _hoisted_60 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-3" }
const _hoisted_61 = { class: "tw-w-full tw-flex tw-items-start tw-flex-col tw-gap-2" }
const _hoisted_62 = {
  key: 0,
  class: "tw-pt-3 tw-box-border tw-border-t-dashed-custom"
}
const _hoisted_63 = {
  key: 5,
  class: "tw-w-full tw-rounded-[10px] tw-border-solid tw-border-[1px] tw-border-[#DFDFDF] tw-bg-white tw-p-4 tw-box-border tw-flex tw-flex-col tw-gap-6"
}
const _hoisted_64 = { class: "tw-w-full tw-flex tw-items-center tw-justify-between" }
const _hoisted_65 = { class: "tw-w-full tw-flex tw-items-center tw-gap-2" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "tw-w-[12px] tw-min-w-[12px] tw-h-[16px]"
}, null, -1))
const _hoisted_67 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-3" }
const _hoisted_68 = { class: "tw-w-full tw-flex tw-items-start tw-flex-col tw-gap-2" }
const _hoisted_69 = {
  key: 0,
  class: "tw-pt-3 tw-box-border tw-border-t-dashed-custom"
}

import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import TradePassportCardSlot from "../slots/TradePassportCardSlot.vue";
import Text from "@/core/components/ui/general/Text.vue";
import Button from "@/core/components/ui/general/Button.vue";
import UnverifiedBadge from "@/core/components/common/UnverifiedBadge.vue";
import VerifiedBadge from "@/core/components/common/VerifiedBadge.vue";
import IdNotVerifiedBadge from "@/core/components/common/IdNotVerifiedBadge.vue";
import { USER_STORE } from "@/store/modules/user";
import { TRADE_ESTIMATE_STORE } from "@/store/modules/trade-estimate";
import { WORKSTATION } from "@/store/modules/workstation";
import { UserRolesEnum } from "@/core/enums/RolesEnum";
import ProfileThumbnail from "@/core/uni-components/ProfileThumbnail.vue";
import UserProfileLogo from "@/core/components/UserProfileLogo.vue";
import { getCombineSameProjectReview } from "@/core/utils/common";
import { REVIEW_RATING_STORE } from "@/store/modules/review-rating";
import { reviewRatingState } from "@/core/models/project-rating";
import { TRADE_PASSPOSRT_ROUTE } from "../../routes";
import {
  BusinessDetailTypeEnum,
  UserVerificationStatusEnum,
} from "@/core/enums/RolesEnum";
import { ProjectRatingTypeEnum } from "@/core/enums/ProjectsEnum";
import CurrencyFilter from "@/filters/currency.filter";
import BlueCircularPencilIcon from "@/core/components/icons/BlueCircularPencilIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TradePassportSummary',
  props: [
  "contractorworkStationImage",
  "userWorkStationImage",
  "userServices",
  "userWorkStationBanner",
],
  emits: ["on-add-rates"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const props = __props;

const store = useStore();
const router = useRouter();

const isLoading = ref(false);

const user = computed(() => store.getters[`${USER_STORE}/user`]);

const getIsOpenTradePassportasViewMode = computed(
  () => store.getters[`${TRADE_ESTIMATE_STORE}/isOpenTradePassportasViewMode`]
);

const isUserProprtyOwner = computed(
  () =>
    user.value?.role?.name === UserRolesEnum.PROPERTY_OWNER ||
    getIsOpenTradePassportasViewMode.value
);

const activeUserWorkstation = computed(() => {
  if (isUserProprtyOwner.value) {
    return store.getters[
      `${TRADE_ESTIMATE_STORE}/getContractorTradePassportDetail`
    ];
  } else {
    return store.getters[`${WORKSTATION}/activeUserWorkstation`];
  }
});

const getDynamicRateLabel = computed(() => {
  const workstation = activeUserWorkstation.value;
  if (!workstation) return "Add Rates";

  const requiredFields = [
    "inpersonVideoFees",
    "videoConsulationFee",
    "emergencyCallOutRate",
    "emergencyCallOutFee",
    "dayRate",
    "hourlyRate",
  ];

  const isTrue = requiredFields.every((field) => workstation[field]);

  return isTrue ? "Edit Rates" : " + Add Rates";
});

const getAllProjectReviewList = computed<
  reviewRatingState["allProjectReviewList"]
>(() => store.getters[`${REVIEW_RATING_STORE}/getAllProjectReviewList`]);

const combineSameProjectReview = computed(() =>
  getCombineSameProjectReview(getAllProjectReviewList.value)
);
const getAverageOfAllProjectReview = computed(() => {
  const totalAvg = combineSameProjectReview.value.reduce(
    (totalRating: number, review: any) => {
      totalRating += review.totalAvg || 0;
      return totalRating;
    },
    0
  );
  return totalAvg
    ? Math.round((totalAvg * 100) / combineSameProjectReview.value.length) / 100
    : totalAvg;
});

const userBusinessType = computed(() => user.value?.userBusinessDetails?.type);

const WorkStationSiltVerificationStatus = computed(
  () => store.getters[`${WORKSTATION}/getWorkStationSiltVerificationStatus`]
);

const userWorkStationStatus = computed(
  () =>
    store.getters[`${WORKSTATION}/activeUserWorkstation`]?.verificationStatus
);

const getLinkData = computed(() => {
  return activeUserWorkstation.value?.workstationLinkTree;
});

const onOpenQr = () => {
  window.open(getLinkData.value?.url, "_blank");
};

const onAddRate = () => {
  emits("on-add-rates");
};

const workstationPostcode = (type: string) => {
  if (activeUserWorkstation.value?.user) {
    return type === BusinessDetailTypeEnum.LIMITED_COMPANY
      ? activeUserWorkstation.value?.user?.userBusinessDetails?.businessPostcode
      : activeUserWorkstation.value?.user?.userBusinessDetails
          ?.residencyPostcode;
  } else {
    return "N/A";
  }
};

const workstationAddress = (type: string) => {
  if (activeUserWorkstation.value?.user) {
    let address;
    if (type === BusinessDetailTypeEnum.LIMITED_COMPANY) {
      const businessAddress =
        activeUserWorkstation.value?.user?.userBusinessDetails?.businessAddress?.replace(
          activeUserWorkstation.value?.user?.userBusinessDetails
            ?.businessPostcode,
          ""
        );
      address = businessAddress?.replace(/,([^,]*)$/, ".$1");
    } else if (
      activeUserWorkstation.value?.user?.userBusinessDetails
        ?.residencyAddressLookup
    ) {
      const residencyAddressLookup =
        activeUserWorkstation.value?.user?.userBusinessDetails?.residencyAddressLookup?.replace(
          activeUserWorkstation.value?.user?.userBusinessDetails
            ?.residencyPostcode,
          ""
        );
      address = residencyAddressLookup?.replace(/,([^,]*)$/, ".$1");
    } else {
      address = `${activeUserWorkstation.value?.user?.userBusinessDetails?.residencyAddressLine} ${activeUserWorkstation.value?.user?.userBusinessDetails?.residencyTown}`;
    }
    return address;
  } else {
    return "N/A";
  }
};

const onClickViewRatings = () => {
  store.dispatch(`${REVIEW_RATING_STORE}/setTradePassportRedirect`, "Reviews");
  router.push({ name: TRADE_PASSPOSRT_ROUTE });
};

onMounted(async () => {
  try {
    isLoading.value = true;
    await store.dispatch(
      `${REVIEW_RATING_STORE}/getAllProjectReviewList`,
      ProjectRatingTypeEnum.TRADER_OWNER
    );
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_rating = _resolveComponent("v-rating")!

  return (_openBlock(), _createBlock(TradePassportCardSlot, {
    class: "trade-passport-summary rlg:!tw-min-w-[416px] rlg:!tw-w-[416px] rlg:!tw-h-[auto]",
    title: "Trade Passport",
    isTitleStrongMobile: true,
    isCustomActionHeader: true,
    hideFooter: true,
    isCustomEmptyState: true
  }, {
    "custom-action-header": _withCtx(() => [
      (!isUserProprtyOwner.value)
        ? (_openBlock(), _createBlock(Button, {
            key: 0,
            variant: "purple-outline",
            label: getDynamicRateLabel.value,
            onClick: onAddRate
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    "custom-empty-state": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          (
              activeUserWorkstation.value?.verificationStatus ===
              _unref(UserVerificationStatusEnum).VERIFIED
            )
            ? (_openBlock(), _createBlock(VerifiedBadge, {
                key: 0,
                label: "Verified"
              }))
            : (_openBlock(), _createBlock(UnverifiedBadge, { key: 1 })),
          (getLinkData.value?.url)
            ? (_openBlock(), _createBlock(Text, {
                key: 2,
                onClick: onOpenQr,
                variant: "h6",
                textWeight: "600",
                class: "!tw-underline tw-cursor-pointer"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("View QR Code")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (!props.userWorkStationBanner)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : _createCommentVNode("", true),
              (props.userWorkStationBanner)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: props.userWorkStationBanner,
                    class: "tw-w-full tw-h-full tw-object-cover"
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (
                  props.contractorworkStationImage || props.userWorkStationImage
                )
                ? (_openBlock(), _createBlock(ProfileThumbnail, {
                    key: 0,
                    isRounded: false,
                    desktopFontSizeBig: true,
                    size: "xlg",
                    mobilSize: "lg",
                    isOnline: true,
                    src: 
                  isUserProprtyOwner.value
                    ? props.contractorworkStationImage
                    : props.userWorkStationImage
                
                  }, null, 8, ["src"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(UserProfileLogo, {
                      isRounded: false,
                      desktopFontSizeBig: true
                    })
                  ])),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(Text, {
                      variant: "h6",
                      textWeight: "400",
                      lineHeight: "18px",
                      class: "rlg:!tw-text-[20px]",
                      textAlign: "left",
                      isCapitalize: true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(activeUserWorkstation.value?.name), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_v_rating, {
                        "active-color": "orange",
                        modelValue: getAverageOfAllProjectReview.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((getAverageOfAllProjectReview).value = $event)),
                        color: "rgba(12, 15, 74, 0.26)",
                        "empty-icon": "mdi-star",
                        readonly: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(Text, {
                        variant: "xsmall",
                        textWeight: "600",
                        lineHeight: "18px",
                        class: "rmd:!tw-text-[12px]",
                        whiteSpace: "nowrap"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getAverageOfAllProjectReview.value) + " out of 5", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    (__props.userServices && __props.userServices.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.userServices, (skill, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (index < 1)
                                ? (_openBlock(), _createElementBlock("div", {
                                    class: "service-badge",
                                    key: index
                                  }, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("img", {
                                        src: 
                                require(`@/assets/category-icons/${skill.iconName}.svg`)
                              ,
                                        class: "tw-w-[8px] tw-min-w-[8px] tw-h-[10px] tw-object-contain white-svg"
                                      }, null, 8, _hoisted_17)
                                    ]),
                                    _createVNode(Text, { variant: "span" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(skill.label), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 256)),
                          (__props.userServices?.length > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createVNode(Text, { variant: "span" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(__props.userServices?.length - 1) + "+", 1)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(Text, {
              textWeight: "500",
              variant: "h4"
            }, {
              default: _withCtx(() => [
                _createTextVNode("0")
              ]),
              _: 1
            }),
            _createVNode(Text, {
              textWeight: "500",
              variant: "span",
              textColor: "rgba(12, 15, 74, 0.7)"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Jobs Completed")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(Text, {
              textWeight: "500",
              variant: "h4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(activeUserWorkstation.value?.userWorkstationMembers.length || 0), 1)
              ]),
              _: 1
            }),
            _createVNode(Text, {
              textWeight: "500",
              variant: "span",
              textColor: "rgba(12, 15, 74, 0.7)"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Connections")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("section", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(Text, {
                variant: "h6",
                textAlign: "left",
                lineHeight: "18px",
                class: "md:!tw-text-[.8rem]"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Trade Network")
                ]),
                _: 1
              })
            ]),
            _createVNode(Text, {
              variant: "p",
              textWeight: "600",
              textColor: "#3366FF",
              whiteSpace: "nowrap",
              class: "tw-cursor-not-allowed"
            }, {
              default: _withCtx(() => [
                _createTextVNode("+Link to Trade Network")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(Text, {
              variant: "p",
              textWeight: "500",
              textColor: "rgba(12, 15, 74, 0.7)",
              lineHeight: "18px",
              textAlign: "left"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Connect with me via iknowa trade network for future collaboration and working together.")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(Button, {
                variant: "purple-outline",
                label: "Connect",
                isActive: false
              })
            ])
          ])
        ]),
        (activeUserWorkstation.value?.dayRate?.minRate)
          ? (_openBlock(), _createElementBlock("section", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(Text, { variant: "h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Regular Day Rate")
                    ]),
                    _: 1
                  })
                ]),
                (!isUserProprtyOwner.value)
                  ? (_openBlock(), _createBlock(BlueCircularPencilIcon, {
                      key: 0,
                      class: "tw-cursor-pointer",
                      onClick: onAddRate
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(Text, {
                    variant: "p",
                    textWeight: "500",
                    textColor: "rgba(12, 15, 74, 0.7)",
                    lineHeight: "18px",
                    textAlign: "left"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Regular Day fee for the services. Hourly rates will vary based on the job complexity.")
                    ]),
                    _: 1
                  }),
                  _createVNode(Text, { variant: "h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(CurrencyFilter).formatToCurrency(
                  activeUserWorkstation.value?.dayRate?.minRate
                )), 1)
                    ]),
                    _: 1
                  })
                ]),
                (isUserProprtyOwner.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      (!isUserProprtyOwner.value)
                        ? (_openBlock(), _createBlock(Button, {
                            key: 0,
                            variant: "purple-outline",
                            label: "Hire Me",
                            isActive: true,
                            isCapitalize: true
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (activeUserWorkstation.value?.hourlyRate?.minRate)
          ? (_openBlock(), _createElementBlock("section", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode(Text, { variant: "h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Regular Hourly Rate")
                    ]),
                    _: 1
                  })
                ]),
                (!isUserProprtyOwner.value)
                  ? (_openBlock(), _createBlock(BlueCircularPencilIcon, {
                      key: 0,
                      class: "tw-cursor-pointer",
                      onClick: onAddRate
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(Text, {
                    variant: "p",
                    textWeight: "500",
                    textColor: "rgba(12, 15, 74, 0.7)",
                    lineHeight: "18px",
                    textAlign: "left"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Regular Hourly fee for the services. Hourly rates will vary based on the job complexity.")
                    ]),
                    _: 1
                  }),
                  _createVNode(Text, { variant: "h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(CurrencyFilter).formatToCurrency(
                  activeUserWorkstation.value?.hourlyRate?.minRate
                )), 1)
                    ]),
                    _: 1
                  })
                ]),
                (isUserProprtyOwner.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      (!isUserProprtyOwner.value)
                        ? (_openBlock(), _createBlock(Button, {
                            key: 0,
                            variant: "purple-outline",
                            label: "Hire Me",
                            isActive: true,
                            isCapitalize: true
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (activeUserWorkstation.value?.emergencyCallOutFee)
          ? (_openBlock(), _createElementBlock("section", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createVNode(Text, { variant: "h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Emergency call-out")
                    ]),
                    _: 1
                  })
                ]),
                (!isUserProprtyOwner.value)
                  ? (_openBlock(), _createBlock(BlueCircularPencilIcon, {
                      key: 0,
                      class: "tw-cursor-pointer",
                      onClick: onAddRate
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(Text, {
                    variant: "p",
                    textWeight: "500",
                    textColor: "rgba(12, 15, 74, 0.7)",
                    lineHeight: "18px",
                    textAlign: "left"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Emergency call-out fee for the services. Hourly rates will vary based on the job complexity.")
                    ]),
                    _: 1
                  }),
                  _createVNode(Text, { variant: "h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(CurrencyFilter).formatToCurrency(
                  activeUserWorkstation.value?.emergencyCallOutFee
                )), 1)
                    ]),
                    _: 1
                  })
                ]),
                (isUserProprtyOwner.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      (!isUserProprtyOwner.value)
                        ? (_openBlock(), _createBlock(Button, {
                            key: 0,
                            variant: "purple-outline",
                            label: "Hire Me",
                            isActive: true,
                            isCapitalize: true
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (activeUserWorkstation.value?.emergencyCallOutRate)
          ? (_openBlock(), _createElementBlock("section", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createVNode(Text, { variant: "h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Emergency call-out Hourly Rate")
                    ]),
                    _: 1
                  })
                ]),
                (!isUserProprtyOwner.value)
                  ? (_openBlock(), _createBlock(BlueCircularPencilIcon, {
                      key: 0,
                      class: "tw-cursor-pointer",
                      onClick: onAddRate
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(Text, {
                    variant: "p",
                    textWeight: "500",
                    textColor: "rgba(12, 15, 74, 0.7)",
                    lineHeight: "18px",
                    textAlign: "left"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Emergency call-out fee for the services Hourly rate. Hourly rates will vary based on the job complexity.")
                    ]),
                    _: 1
                  }),
                  _createVNode(Text, { variant: "h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(CurrencyFilter).formatToCurrency(
                  activeUserWorkstation.value?.emergencyCallOutRate
                )), 1)
                    ]),
                    _: 1
                  })
                ]),
                (isUserProprtyOwner.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      (!isUserProprtyOwner.value)
                        ? (_openBlock(), _createBlock(Button, {
                            key: 0,
                            variant: "purple-outline",
                            label: "Hire Me",
                            isActive: true,
                            isCapitalize: true
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (activeUserWorkstation.value?.videoConsulationFee)
          ? (_openBlock(), _createElementBlock("section", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createVNode(Text, { variant: "h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Video Consultation Rate")
                    ]),
                    _: 1
                  })
                ]),
                (!isUserProprtyOwner.value)
                  ? (_openBlock(), _createBlock(BlueCircularPencilIcon, {
                      key: 0,
                      class: "tw-cursor-pointer",
                      onClick: onAddRate
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(Text, {
                    variant: "p",
                    textWeight: "500",
                    textColor: "rgba(12, 15, 74, 0.7)",
                    lineHeight: "18px",
                    textAlign: "left"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Video Consultation fee. Hourly rates will vary based on the job complexity.")
                    ]),
                    _: 1
                  }),
                  _createVNode(Text, { variant: "h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(CurrencyFilter).formatToCurrency(
                  activeUserWorkstation.value?.videoConsulationFee
                )), 1)
                    ]),
                    _: 1
                  })
                ]),
                (isUserProprtyOwner.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      (!isUserProprtyOwner.value)
                        ? (_openBlock(), _createBlock(Button, {
                            key: 0,
                            variant: "purple-outline",
                            label: "Hire Me",
                            isActive: true,
                            isCapitalize: true
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (activeUserWorkstation.value?.inpersonVideoFees)
          ? (_openBlock(), _createElementBlock("section", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createVNode(Text, { variant: "h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Video Consultation Rate")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(BlueCircularPencilIcon, {
                  class: "tw-cursor-pointer",
                  onClick: onAddRate
                })
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _createVNode(Text, {
                    variant: "p",
                    textWeight: "500",
                    textColor: "rgba(12, 15, 74, 0.7)",
                    lineHeight: "18px",
                    textAlign: "left"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("In-Person Consultation fee. Hourly rates will vary based on the job complexity.")
                    ]),
                    _: 1
                  }),
                  _createVNode(Text, { variant: "h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(CurrencyFilter).formatToCurrency(
                  activeUserWorkstation.value?.inpersonVideoFees
                )), 1)
                    ]),
                    _: 1
                  })
                ]),
                (isUserProprtyOwner.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                      (!isUserProprtyOwner.value)
                        ? (_openBlock(), _createBlock(Button, {
                            key: 0,
                            variant: "purple-outline",
                            label: "Hire Me",
                            isActive: true,
                            isCapitalize: true
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})